/* ToDo: Remove this file, doesn´t seem like it is being used */

import { FETCH_SEARCH_TEXT } from "./actions.type";
import { SET_SEARCH_TEXT } from "./mutations.type";

const state = {
  searchText: "",
};


export const actions = {
  [FETCH_SEARCH_TEXT]({commit}, text) {
    commit(SET_SEARCH_TEXT, text);
  },
}

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
  [SET_SEARCH_TEXT](state, text) {
    state.searchText = text;
  }
};

const getters = {
  searchText() {
    return state.searchText
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
